module.exports = __webpack_public_path__ + "static/logo-0d52f8575a251eff8ebd6e2d6bd6c51b.png";